import { H2 } from "components/ui/typography/titles/Titles"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { useFillesTableStore } from "store/table.store"
import { useAuth } from "hooks/api/auth/auth.hook"
import style from "./PasswordChanged.module.scss"

const { passwordChanged, title, text } = style

export const PasswordChanged = () => {
	const { logout } = useAuth()
	const { resetSessionStoragePagination } = useFillesTableStore()

	const logoutHandle = () => {
		logout()
		resetSessionStoragePagination()
	}

	return (
		<div className={passwordChanged}>
			<H2 className={title}>Password has been successfully changed!</H2>
			<p className={text}>Please log in again to continue</p>
			<ButtonPrimary onClick={logoutHandle}>Log out</ButtonPrimary>
		</div>
	)
}
